import { render, staticRenderFns } from "./CodingClinicalExamples.vue?vue&type=template&id=5789f150&scoped=true&"
import script from "./CodingClinicalExamples.vue?vue&type=script&lang=js&"
export * from "./CodingClinicalExamples.vue?vue&type=script&lang=js&"
import style0 from "./CodingClinicalExamples.vue?vue&type=style&index=0&id=5789f150&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5789f150",
  null
  
)

export default component.exports